import { render, staticRenderFns } from "./AboutCaratDialog.vue?vue&type=template&id=4c2b378a&"
import script from "./AboutCaratDialog.vue?vue&type=script&lang=ts&"
export * from "./AboutCaratDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports